import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Zap, DollarSign, Settings, CreditCard, X, BookOpen, Mail } from 'lucide-react';
import { useAuth } from '@/components/auth/AuthProvider';
import Logo from '@/components/brand/Logo';

interface MobileSidebarProps {
 isOpen: boolean;
 onClose: () => void;
}

export default function MobileSidebar({ isOpen, onClose }: MobileSidebarProps) {
 const { user } = useAuth();

 const menuItems = [
 { label: 'Accueil', path: '/', icon: Home, show: true },
 { label: 'Studio', path: '/studio', icon: Zap, show: true },
 { label: 'Tarifs', path: '/pricing', icon: DollarSign, show: true },
 { label: 'Journal', path: '/blog', icon: BookOpen, show: true },
 { label: 'Contact', path: '/contact', icon: Mail, show: true },
 { label: 'Paramètres', path: '/settings', icon: Settings, show: !!user },
 { label: 'Facturation', path: '/billing', icon: CreditCard, show: !!user },
 ];

 return (
 <>
 {isOpen && (
 <div
 className="fixed inset-0 bg-theme-base/50 z-40 md:hidden"
 onClick={onClose}
 aria-hidden="true"
 />
 )}

 <div
 className={`
 fixed inset-y-0 left-0 z-50 w-72
 bg-theme-surface border-r border-theme
 transform transition-transform duration-300 ease-out
 md:hidden
 ${isOpen ? 'translate-x-0' : '-translate-x-full'}
 `}
 >
 <div className="flex items-center justify-between p-4 border-b border-theme">
 <Link to="/" onClick={onClose} className="flex items-center">
 <Logo wordmark />
 </Link>
 <button
 onClick={onClose}
 className="p-2 text-theme-secondary hover:text-theme-primary"
 aria-label="Fermer le menu"
 >
 <X className="w-5 h-5" strokeWidth={1.5} />
 </button>
 </div>

 <nav className="p-3">
 <div className="space-y-0.5">
 {menuItems
 .filter(item => item.show)
 .map((item) => (
 <Link
 key={item.path}
 to={item.path}
 onClick={onClose}
 className="flex items-center gap-3 px-3 py-2.5 text-theme-secondary hover:text-theme-primary hover:bg-theme-hover"
 >
 <item.icon className="w-4 h-4" strokeWidth={1.5} />
 <span className="text-sm">{item.label}</span>
 </Link>
 ))}
 </div>
 </nav>

 <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-theme">
 <p className="text-[10px] tracking-[0.18em] uppercase text-theme-tertiary text-center">
 Clairify · France
 </p>
 </div>
 </div>
 </>
 );
}
